// src/config/ProductAndControl.js
import { HttpBindingReportService } from "../services/BindingReportService";
import { ProductControl } from "../controls/ProductControl";

/** Builds the service + ProductControl and inserts the drawer as a full-width sidebar section just above `target` (.vector-feature) in #controls-left. */
export function addProductControl(map, target) {
  const service = new HttpBindingReportService(process.env.BINDING_REPORTS_URL);
  const control = new ProductControl({ service });
  map.addControl(control);
  // Place the drawer as a full-width sidebar section directly above the layer
  // area — a sibling of `target` (.vector-feature) in #controls-left — so its
  // grey separator is flush and end-to-end like the other sidebar sections,
  // not an inset card+divider inside the padded .vector-feature.
  target.parentNode.insertBefore(control.element, target);
  return control;
}
